import styled from 'styled-components'

const PageContent = styled.div`
	margin: 0 auto;
	max-width: 960px;
	padding: 1rem;
`
export default PageContent
